import {MaybeCoreObject} from 'app-core/framework/CoreObjectConstants';
import {DomainGraphInterface} from 'app-core/framework/CoreObjectConstants';
import {
  doesObjectHaveInterface,
  getObjectType,
  isCoreObject,
} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {
  DEFAULT_ARCHIVEABLE_CONFIGURATION,
  getPlatformConfiguration,
} from 'app-core/framework/PlatformConfiguration';

import {MaybeArchivableItem} from './ArchiveConstants';
import canHaveArchiveRecord from './canHaveArchiveRecord';

/**
 * Preferred modern implementation of `isArchivable` that can handle all types of archival:
 * - Legacy REST representation
 * - Legacy GraphQL (pre-Core Object) representation
 * - Modern Core Object GraphQL representation
 */
export default function isArchivable(item: MaybeCoreObject): item is MaybeArchivableItem {
  const isCoreObjectArchivable =
    isCoreObject(item) && doesObjectHaveInterface(item, DomainGraphInterface.CORE_OBJECT_ARCHIVABLE);
  const isLegacyArchivable = canHaveArchiveRecord(item.id);
  let isPlatformCapabilityEnabledForItemInstance = true;
  if (isCoreObject(item)) {
    const itemType = getObjectType(item);
    const config = getPlatformConfiguration(
      DomainGraphInterface.CORE_OBJECT_ARCHIVABLE,
      itemType,
      DEFAULT_ARCHIVEABLE_CONFIGURATION
    );

    isPlatformCapabilityEnabledForItemInstance = config.isPlatformCapabilityEnabledForItemInstance(item);
  }
  return (isCoreObjectArchivable || isLegacyArchivable) && isPlatformCapabilityEnabledForItemInstance;
}
